import axios, { AxiosResponse } from 'axios';
import type { Envelope, Meta } from '../types';

export const TOKEN_KEY = 'kloabsen_app_admin_token';

const api = axios.create({ baseURL: process.env.REACT_APP_API_BASE_URL });

api.interceptors.request.use((config) => {
  config.headers = config.headers ?? {};
  config.headers['X-Api-Key'] = process.env.REACT_APP_API_KEY ?? '';
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers['Authorization'] = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem(TOKEN_KEY);
      const loginPath = `${process.env.PUBLIC_URL ?? ''}/login`;
      if (window.location.pathname !== loginPath) window.location.href = loginPath;
    }
    const message = error?.response?.data?.message ?? error.message ?? 'Request failed';
    const err = new Error(message) as Error & { fields?: Record<string, string[]> };
    const fieldErrors = error?.response?.data?.data;
    if (fieldErrors && typeof fieldErrors === 'object' && !Array.isArray(fieldErrors)) {
      err.fields = fieldErrors;
    }
    return Promise.reject(err);
  },
);

export function unwrap<T>(res: AxiosResponse<Envelope<T>>): T {
  return res.data.data;
}

export function unwrapList<T>(res: AxiosResponse<Envelope<T[]>>): { data: T[]; meta?: Meta } {
  return { data: res.data.data, meta: res.data.meta };
}

export default api;
